import type { PortfolioProps } from '../../types/portfolio'
import Work from './Work'
export default function Portfolio({
    hasSeenProjects,
    onVisible,
}: PortfolioProps) {
    return (
        <>
            <Work onVisible={onVisible} hasSeenProjects={hasSeenProjects} />
        </>
    )
}
